export default "__VITE_ASSET__16e2a3b7__"